import { graphql, readFragment } from "@opensea/graphql";
import { useDateTimeFormatter } from "@opensea/i18n";
import { Chip, Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
export const CollectionCreatedAtChipFragment = graphql(`
  fragment CollectionCreatedAtChip on Collection {
    createdAt
  }
`);
export function CollectionCreatedAtChip(t0) {
  const {
    collection: collectionKey,
    variant: t1,
    chipVariant
  } = t0;
  const variant = t1 === undefined ? "full" : t1;
  const collection = readFragment(CollectionCreatedAtChipFragment, collectionKey);
  const t = useTranslations("CollectionCreatedAtChip");
  const dateFormat = useDateTimeFormatter();
  const createdAt = dateFormat(new Date(collection.createdAt), {
    display: "date",
    day: undefined
  });
  return variant === "compact" ? <Tooltip content={t("launched", {
    createdAt
  })}><Chip variant={chipVariant}>{createdAt}</Chip></Tooltip> : <Chip variant={chipVariant}>{t("launched", {
      createdAt
    })}</Chip>;
}